//与app交互相关
//P.S. IOS有坑，IOS如下方法不能同一时间调用多个，如有需求，请加延时。。。
//
var appPlat = 1;
var bridge = {
	isHybrid:function(){
		//m.guba.east  mcs.guba.east  mguba.east
		if(this.isAndroid()){
			return "android";
		}else if(appPlat == 0){
			return false;
		}else if(this.isWeixin()||this.isQQ()||this.isWeibo()){
			return false;
		}else if(navigator.platform=="Win32" || navigator.platform=="MacIntel"){
			return false;
		}else if(this.isIOS()){
			return "ios";
		}else{
			return false;
		}
	},
	inInBrowser:function(){
		if(window.embedHelper.cookie.get("isinbrowser")==1){
			return true;
		}
		// if(window.location.href.indexOf("isinbrowser")>=1){
		if(appPlat == 0){
			window.embedHelper.cookie.set("isinbrowser","1");
			return true;
		}
		return false;
	},
	/*
	 * 判断操作系统
	 */
	isIOS:function() {
    if (/(iPhone|iPod|iPad|iTouch|iOS)/i.test(navigator.userAgent)) {
        return true;
    }else{
        return false;
    }
	},

	isAndroid:function(){
		// if(/Android/i.test(navigator.userAgent) && (appPlat != 0)) {
		if(/Android/i.test(navigator.userAgent)) {
	        return true;
	    }else{
	        return false;
	    }
	},
	isQQ:function(){
	    if (/QQ/i.test(navigator.userAgent)) {
	        return true;
	    }else{
	        return false;
	    }
	},
	isWeixin:function(){
	    if (/MicroMessenger/i.test(navigator.userAgent)) {
	        return true;
	    }else{
	        return false;
	    }
	},
	isWeibo:function(){
		if (/weibo/i.test(navigator.userAgent.toLowerCase())) {
				return true;
		}else{
				return false;
		}
	},

	/*
	 * 初始化
	 */
	emSendPageInfoToAPP:function(param) {
		var jsonStr = JSON.stringify(param);
    if (this.isIOS()) { //IOS
	    if(window.webkit && window.webkit.messageHandlers){
				window.webkit.messageHandlers.emSendPageInfoToAPP.postMessage(jsonStr);
			}else{
				eastmoney.emSendPageInfoToAPP(jsonStr);
			}
    }else { //android
			prompt('emSendPageInfoToAPP',jsonStr);
    }
	},

	emSendBackInfoToAPP:function(param) {
		var jsonStr = JSON.stringify(param);
    if (this.isIOS()) { //IOS
			if(window.webkit && window.webkit.messageHandlers){
				window.webkit.messageHandlers.emSendBackInfoToAPP.postMessage(jsonStr);
			}else{
				eastmoney.emSendBackInfoToAPP(jsonStr)
			}
    }else { //Android
			prompt('emSendBackInfoToAPP',jsonStr);
    }
	},

	// 跳转PDF
	triggerPageAction:function(param) {
		// {"type":"openPDF", "param":{"url":"xxx"}}
		var jsonStr = JSON.stringify(param);
		if (this.isIOS()) { //IOS
			if(window.webkit && window.webkit.messageHandlers){
				window.webkit.messageHandlers.triggerPageAction.postMessage(jsonStr);
			}else{
				eastmoney.triggerPageAction(jsonStr);
			}
		}else { //android
				prompt('triggerPageAction',jsonStr);
		}
	},
	triggerPageActionForPE:function(param) {
		// {"type":"openPDF", "param":{"url":"xxx"}}
		var jsonStr = JSON.stringify(param);
		if (this.isIOS()) { //IOS
			window.location = 'triggerPageAction:' + jsonStr;
			// window.location = 'emOpenImages:' + jsonStr;
		}else { //android
			prompt('triggerPageAction',jsonStr);
		}
	},

	// // 	获取大表情 dbq
	emGetBigEmoji: function(titleArr,callbackname){
		var param = {
			"callbackname":callbackname,
			"title":titleArr
		}
		var jsonStr = JSON.stringify(param);
		if (this.isIOS()) {
			if(window.webkit && window.webkit.messageHandlers){
				window.webkit.messageHandlers.emGetBigEmoji.postMessage(jsonStr);
			}else{
				eastmoney.emGetBigEmoji(jsonStr)
			}
		}else{
			prompt('emGetBigEmoji',jsonStr);
		}
	},


	// 跳转用户中心
	// dfcft://gubauserhome?uid=XXXXXX &anchor=（0动态，1股吧，5，专栏，4问答） &usertype=(0未知，1普通，2财富号)
	jumpToUser:function(uid,usertype) {
		if (this.isIOS()) {
			window.location.href = 'eastmoney://wireless/stockbarselfpage?userid='+ uid +'&anchor=1'+'&usertype='+usertype;
		}else{
			// alert('dfcft://gubauserhome?uid='+ uid +'&anchor=1'+'&usertype='+usertype)
			window.location.href = 'dfcft://gubauserhome?uid='+ uid +'&anchor=1'+'&usertype='+usertype;
		}
	},

	// 跳转原生正文页面
	jumpToSourcePost:function(postid,type) {
		if(this.isIOS()){
			window.location.href = "eastmoney://wireless/"+"gubacontent?postid="+postid+"&posttype="+type+"&tocomment=0"
		}else{
			this.appendIframe("dfcft://"+"gubacontent?postid="+postid+"&posttype="+type+"&tocomment=0");
		}
	},

	// 跳转原生正文页面并且滑动到评论处
	jumpToSourcePostReply:function(postid,type) {
		if(this.isIOS()){
			window.location.href = "eastmoney://wireless/"+"gubacontent?postid="+postid+"&posttype="+type+"&tocomment=1"
		}else{
			this.appendIframe("dfcft://"+"gubacontent?postid="+postid+"&posttype="+type+"&tocomment=1");
		}
	},

	/*
	 * 显示隐藏顶通
	 * @param  {[type]} type [1:显示顶通,0:不显示顶通]
	 */
	scrollToShow:function(type) {
		if(type == "1"){
			if(this.isIOS()){
				if(window.webkit && window.webkit.messageHandlers){
					window.webkit.messageHandlers.scrollToShow.postMessage('{"action":"show"}');
				}else{
					eastmoney.scrollToShow('{"action":"show"}')
				}
			}else{
				prompt('scrollToShow','{"action":"show"}');
			}
		}else{
			if(this.isIOS()){
				if(window.webkit && window.webkit.messageHandlers){
					window.webkit.messageHandlers.scrollToShow.postMessage('{"action":"hide"}');
				}else{
					eastmoney.scrollToShow('{"action":"hide"}')
				}
			}else{
				prompt('scrollToShow','{"action":"hide"}');
			}
		}
	},

	/*
	 * 触发调用
	 */
	eventGetLoginStatus:function(callback) {
		var jsonStr = '{"callbackname":"'+callback+'"}';
	    if (this.isIOS()) { //IOS
	    	// (new Image()).src="emH5GetLoginStatus:" + jsonStr;
	    	window.location = "emH5GetLoginStatus:" + jsonStr;
	    	//appendIframe("emH5GetLoginStatus:" + jsonStr);
	    }else{ //Android
			prompt('emH5GetLoginStatus',jsonStr);
	    }
	},

	/**
	 * 原生登录
	 * @param  {Function} callback [description]
	 * @return {[type]}            [description]
	 */
	eventLogin:function(callback){
		var jsonStr = '{"callbackname":"'+callback+'","textmsg":"","wechat":"1","qq":"1","sina":"1"}';
		if(this.isIOS()){
			window.location = "emH5NativeLogin:" + jsonStr;
		}else{
			if(typeof(window.eastmoney)!="undefined"){
				eastmoney.emH5NativeLogin(jsonStr);
			}
		}
	},


	// jsonStr：
	// 	{
	// 		"type": "more,guba",
	// 		"title": "填入分享标题",
	// 		"img": "填入分享头图地址",
	// 		"url": "填入分享链接地址",
	// 		"desc": "填入分享说明",
	// 		"data": {
	// 			"title": "标题",
	// 			"content": "内容",
	// 			"userid": "被转发用户id",
	// 			"id": "帖子id",
	// 			"userv": "ios需要",
	// 			"nickname": "被转发用户昵称",
	// 			"stockcode","被转发股吧id ，android需要，没有可以不传"
	// 		}
	// 	}
	// 	主动触发用
	emH5Share:function(param){
		param.callbackname = "callbackShare";
		var jsonStr = JSON.stringify(param);
	    if (this.isIOS()) { //IOS
	        window.location = "onwebshareclicked:" + jsonStr;
	    }
	    else { //Android
	        eastmoney.onShareClicked(jsonStr);
	    }
	},

	// 	主动触发用
	emh5grabredpacket:function(json){
		var jsonStr = JSON.stringify(json);
	    if (this.isIOS()) { //IOS
			// window.location = "emh5grabredpacket:";
			if(window.webkit && window.webkit.messageHandlers){
				window.webkit.messageHandlers.triggerPageAction.postMessage(jsonStr);
			}else{
				eastmoney.triggerPageAction(jsonStr);
			}
	    }else{ //Android
			prompt("triggerPageAction",jsonStr);
	    }
	},

	// 实名弹窗
	emOpenOptRealNameDialog:function(json,callbackname){
			// 掉红包交互回调
			window.emh5grabredpacketCB = function(res){
				if(window.embedHelper.Bridge.isAndroid()){
					if(JSON.parse(res).code != 0){
						return;
					}
				}else{
					if(res != "success"){
						return;
					}
				}

				window.embedHelper.Bridge.emh5grabredpacket(json);
			}
			var json2 = {
				"callbackname":callbackname
			}
			var jsonStr = JSON.stringify(json2);
			if (this.isIOS()) {
				if(window.webkit && window.webkit.messageHandlers){
					window.webkit.messageHandlers.emOpenOptRealNameDialog.postMessage(jsonStr);
				}else{
					eastmoney.emOpenOptRealNameDialog(jsonStr)
				}
	    }else{
	    	prompt('emOpenOptRealNameDialog',jsonStr);
	    }
	},

	/**
	 * 调用native回复输入框
	 * @param  {[type]} tid    [description]
	 * @param  {[type]} hid    [description]
	 * @param  {[type]} h_name [description]
	 * @return {[type]}        [description]
	 */
	emH5ReplyInput:function(tid,hid,h_name,callback){
		window.callbackGubaReplyInput=function(param){
			//{"data":{"tid":"xxxxxxxxx"},"msg":"","code":0}		//code 0=>成功 1=>失败
			if(callback){
				callback(param);
			}
		}
		var param = {
			"tid": tid,
			"hid": hid,
			"h_name": h_name,
			"callbackname": "callbackGubaReplyInput"
		}
		var jsonStr = JSON.stringify(param);
        if (this.isIOS()) {
            this.callIOSNative("emH5ReplyTieZi:" + jsonStr);
        }else{
        	eastmoney.emH5ReplyTieZi(jsonStr)
        }
	},

	/**
	 * 调用native发帖
	 * @return {[type]} [description]
	 */
	emH5PublishTopic:function(code,topicId,topicName,callback){
		window.callbackGubaPublish=function(param){
			//{"data":{"tid":"xxxxxxxxx"},"msg":"","code":0}		//code 0=>成功 1=>失败
			if(callback){
				callback(param);
			}
		}
		var param = {
			"code": code,
			"topic_id":topicId,
			"topic_name":topicName,
			"callbackname": "callbackGubaPublish"
		}
		var jsonStr = JSON.stringify(param);
        if (this.isIOS()) {
            this.callIOSNative("emH5PostTieZi:" + jsonStr);
        }else{
        	eastmoney.emH5PostTieZi(jsonStr)
        }
	},

	/**
	 * 调用native图片浏览
	 * @return {[type]} [description]
	 */
	emH5ImgGallary:function(param){
		var jsonStr = JSON.stringify(param);
        if (this.isIOS()) {
			window.location = 'emOpenImages:' + jsonStr;
        }else{
			// eastmoney.emOpenImages(jsonStr)
			prompt('emOpenImages',jsonStr)
        }
	},

   /**
	* 改native头
	*
	*
	*/
	emH5Title:function(title) {
		var jsonStr= '{"title1":"'+title+'"}';
	    try {
	        if (this.isIOS()) {
	        	this.callIOSNative("emH5Title:" + jsonStr);
	        }else{
	        	eastmoney.emH5Title(jsonStr);//android
	        }

	        //return false;
	    } catch (e) {
	        return false;
	    }
	},

	/**
	 * 设置右侧刷新按钮启动
	 * @param  {[type]} param [description]
	 * @return {[type]}       [description]
	 */
	emH5SetTitleRightRefresh:function(enable){
		var param = {
            "type": "refresh",
            "enable": enable,
            "callbackname":"onIOSNativeRefreshCall"
        };
        var jsonStr = JSON.stringify(param);
        if (this.isIOS()) {
        	this.callIOSNative("emSetTitleRightBtn:" + jsonStr);
        }else{
        	eastmoney.emSetTitleRightBtn(jsonStr);//android
        }
	},

	/**
	 * 设置右侧搜索按钮
	 * @param  {[type]} param [description]
	 * @return {[type]}       [description]
	 */
	emH5SetTitleRightSearch:function(enable){
		var param = {
            "type": "search",
            "enable": enable,
            "callbackname":"onIOSNativeSearchCall"
        };
        var jsonStr = JSON.stringify(param);
        if (this.isIOS()) {
        	this.callIOSNative("emSetTitleRightBtn:" + jsonStr);
        }else{
        	eastmoney.emSetTitleRightBtn(jsonStr);//android
        }
	},

	/**
	*	定制native头部回退按钮
	*
	*
	*/
	// goBack : function () {
	//     // if (typeof (BackPage) == "undefined") {
	//     //     if (this.isIOS()) {
	//     //         window.location = "goWhere:";
	//     //         return 1;
	//     //     }

	//     //     window.eastmoney.goWhere();
	//     // }
	//     // else {
	//     //     window.location = BackPage;
	//     //     return 1;
	//     // }
	//     window.embedHelper.goBack();
	// },

	closeWebview:function(){
	    if (this.isIOS()) {
	        window.location = "goWhere:";
	        return 1;
	    }
	    window.eastmoney.goWhere();
	},

	/**
	 * 跳转股票 mary
	 * @param  {[type]} code [description]
	 * @param  {[type]} name [description]
	 * @return {[type]}      [description]
	 */
	emH5ToStock:function(code,name){
        if (this.isIOS()) {
        	return 'eastmoney://em.dpl/page/stockdetail/'+code
        }else{
        	return 'dfcft://stock?stockcode='+code+'&stockname='+name
        }
	},
	emAlert: function(param){//弹窗方法
		var jsonStr = JSON.stringify(param);
		//var jsonStr = param;

		if (this.isIOS()) {
			if(window.webkit && window.webkit.messageHandlers){
				window.webkit.messageHandlers.emToast.postMessage(jsonStr);
			}else{
				eastmoney.emToast(jsonStr)
			}
    }else{
    	prompt('emToast',jsonStr);
    }
	},
	emComfirm: function(param){//弹窗方法
		var jsonStr = JSON.stringify(param);
		if (this.isIOS()) {
			window.location = "emH5toNativeAlterView:" + jsonStr;
		}else{
			prompt('emH5toNativeAlterView',jsonStr);
		}
	},

	/**
	 * 跳转个股列表页
	 * @param  {[type]} code [description]
	 * @param  {[type]} name [description]
	 * @return {[type]}      [description]
	 */
	emH5ToStockList:function(code,name){
		var param = {
            "stockName": name+"",
            "stockCode": code.toUpperCase()+""
        };
        var jsonStr = JSON.stringify(param);
        if (this.isIOS()) {
        	this.callIOSNative("emH5ToNativePage:" + jsonStr);
        }else{
        	// prompt('emH5ToNativePage',jsonStr);
					this.appendIframe("dfcft://stock?stockcode="+ code.toUpperCase() +"&stockname="+ name);
        }
	},

	/**
	 * 跳转个股列表页，并定位到股吧签
	 * @param  {[type]} code [description]
	 * @param  {[type]} name [description]
	 * @return {[type]}      [description]
	 */
	emH5ToStockListGuba:function(code,name){
		var param = {
						"stockname": name+"",
						"stockcode": code.toUpperCase()+"",
						"anchor":"0"
				};
				var jsonStr = JSON.stringify(param);
				if (this.isIOS()) {
					// this.callIOSNative("emH5ToNativePage:" + jsonStr);
					this.appendIframe("eastmoney://page/stockpage?code="+code.toUpperCase()+"&content=1&scroll=1");
				}else{
					this.appendIframe("dfcft://stock?stockcode="+ code.toUpperCase() +"&stockname="+ name+"&anchor=0");
				}
	},

	/**
	 * 跳转主题吧
	 * @param  {[type]} code [description]
	 * @param  {[type]} name [description]
	 * @return {[type]}      [description]
	 */
	emH5ToStockBar:function(code,name){
		if(this.isIOS()){
			this.appendIframe("eastmoney://wireless/themebarhome?code="+ code +"&name="+ name);
		}else{
			this.appendIframe("dfcft://themebarhome?code="+ code +"&name="+ name);
		}
	},

	/**
	 * 兼容app低版本的跳转h5方式
	 * @param  {[type]} code [description]
	 * @param  {[type]} name [description]
	 * @return {[type]}      [description]
	 */
	emH5ToHref:function(href){
		if (this.isIOS()) {
			return "window.location.href = 'eastmoney://page/openaccountwithurl?url=" + href+"'";
		}else{
			return "window.location.href = 'dfcft://kaihu?url="+ href+"'";
		}
	},
	/**
	 * 添加自选股
	 * @return {[type]} [description]
	 */
	emH5AddStocks:function(stocks,cb){
		var json = {
			"callbackname":"window.embedHelper.bridge.emH5AddStocksCB",
			"stocks":stocks
		}
		var jsonStr = JSON.stringify(json);
	    try {
	        if (this.isIOS()) {
	            window.location = "emAddStocks:" + jsonStr;//ios
	        }
	        else{
	        	eastmoney.emAddStocks(jsonStr);//android
	        }
	        //return false;
	    } catch (e) {
	        return false;
	    }
	},

	// var jsonStr = '{"callbackname":"callbackLogin","txtmsg":"xxxxxxxxxxxxx","wechat":"1","qq":"1","sina":"1"}';
	// 定制头部分享用
	emH5ShareNeed : function(need,title,url,desc) {
		//1代表需要,0代表不需要
		var need = need?"1":"0";
		window.sharedInfo = {};
		if(need){
			window.sharedInfo.callbackname="window.embedHelper.callbackShare";
			window.sharedInfo.type="weixin,pengyouquan,qq,qzone,weibo";
			window.sharedInfo.title=title;
			window.sharedInfo.img=window.location.protocol+"//gbfek.dfcfw.com/libs/share/weixin-share.png";
			window.sharedInfo.url=url;
			window.sharedInfo.desc=desc;

		}
	    try {
	        if (this.isIOS()) {
	            window.location = "emH5ShareNeed:" + need;//ios
	        }
	        else{
	        	eastmoney.emH5ShareNeed(need);//android
	        }
	        //return false;
	    } catch (e) {
	        return false;
	    }
	},


	/*
	 * js触发分享
	 */
	eventShareOnTitle:function() {
		var jsonStr = JSON.stringify(window.sharedInfo);
	    if (this.isIOS()) { //IOS
	        window.location = "onwebshareclicked:" + jsonStr;
	    }
	    else { //Android
	        eastmoney.onShareClicked(jsonStr);
	    }
	},

	/*
	 * 定义回调
	 *
	 * 返回值'returnValue'为json串：{'code':'0','data':'','msg':''}
	 * code：登陆成功状态，0=成功，1=失败，2=未安装相关app（仅微信用）
	 * data：返回null（保留字段）
	 * msg： 调试时返回调试数据用，正式发包是返回空值
	 */
	callbackShare:function(returnValue){
	 	var str = JSON.parse(returnValue);

	    if (str.code == "0") {
	        //分享成功
	    }
	    else if (str.code == "2") {
	        //未安装微信
	    }
	    else {
	        //分享失败
	    }
	},

	/**
	 * 统一调用ios交互方式
	 * @param  {[type]} url [description]
	 * @return {[type]}     [description]
	 */
	callIOSNative:function(url){
		this.appendIframe(url);
		//window.location = url;//"emOpenImages:" + json;
	},

	/**
	 * 调用本地链接类跳转调用
	 * @param  {[type]} url [description]
	 * @return {[type]}     [description]
	 */
	emH5Jump:function(url){
		if(this.isIOS()){
			this.appendIframe("eastmoney://wireless/h5/trade?url="+url);
		}else{
			this.appendIframe("dfcft://webh5?url="+url);
		}
	},
	/**
	 * 调用本地链接类跳转调用
	 * @param  {[type]} url [description]
	 * @return {[type]}     [description]
	 */
	emH5JumpNative:function(url){
		if(this.isIOS()){
			this.appendIframe("eastmoney://wireless/"+url);
		}else{
			this.appendIframe("dfcft://"+url);
		}
	},
	/**
	 * 获取app基础信息(6.5支持)
	 * @return {[type]} [description]
	 */
	getAppInfo:function() {
		var jsonStr = '{"callbackname": "emH5GetAppInfoCB","type": "passport, trade"}';
		if(this.inInBrowser()){
			return ;
		}else if (this.isIOS()) { //IOS
				window.location = "h5getmoduleinfo:" + jsonStr;
		}else{ //Android
			prompt("h5GetModuleInfo",jsonStr)
			// eastmoney.h5GetModuleInfo(jsonStr)
		}
	},

	/**
	 * 获取app基础信息中的网络信息
	 * @return {[type]} [description]
	 */
	getNetworkStateAppInfo:function() {
		var jsonStr = '{"callbackname": "emH5GetNetworkStateCB","type": "deviceInfo"}';
		if (this.isIOS()) {
			window.location = "h5getmoduleinfo:" + jsonStr
		} else {
			if (typeof(window.eastmoney) != "undefined") {
				eastmoney.h5GetModuleInfo(jsonStr)
			}
		}
	},

	/**
	 * 获取app基础信息(6.0支持)
	 * @return {[type]} [description]
	 */
	eventGetSystemInfo:function(){
		if(this.isHybrid()){
			var jsonStr = '{"callbackname":"emH5GetSystemInfoCB"}';
		    if (this.isIOS()) { //IOS
		        // window.location = "getDeviceInfo:" + jsonStr;
		        this.appendIframe("getDeviceInfo:" + jsonStr);
		    }else{ //Android
		    	prompt("getDeviceInfo",jsonstr)
		    	// eastmoney.getDeviceInfo(jsonStr)
		    }
		}
	},

	/**
	 * 添加看不见的iframe
	 * @param  {[type]} url [description]
	 * @return {[type]}     [description]
	 */
	appendIframe:function(url){
		var url = url;
		var iframe = document.createElement('iframe');
		iframe.style.width = '1px';
		iframe.style.height = '1px';
		iframe.style.display = 'none';
		iframe.src = url;
		iframe.class="app_jsbridge";
		document.body.appendChild(iframe);
		setTimeout(function() {
		    iframe.remove();
		}, 1000);
	},
}
// window.callbackShare = function(res){
// 	window.embedHelper.bridge.callbackShare(res);
// }
//右上角分享回调
window.emH5ShareInfo = function(){
	window.embedHelper.bridge.eventShareOnTitle()
}
//IOS右上角刷新回调
window.onIOSNativeRefreshCall = function(){
	window.location.reload();
}
//IOS右上角搜索回调
window.onIOSNativeSearchCall = function(){
	setTimeout(function(){
		window.embedHelper.observer.trigger("page_home_clear_topicList");
		window.embedHelper.forwardTo("/topic_search");
	},10)
}
//APP信息获取
window.emH5GetAppInfoCB=function(res){
	setTimeout(function(){
		var obj = JSON.parse(res)
		if(obj['data']){
			window.appPassport = obj['data']['passport']
			//todo  permistion_level2 取出是否有权限

			// alert(window.appPassport.isLoginGMTrade)
			// alert(window.appPassport.isLoginHSTrade)
		}
		//isLoginHsTrade沪深
		////isLoginGMTrade港美
	},10)
}

window.emH5GetSystemInfoCB=function(res){
	setTimeout(function(){
		var obj = JSON.parse(res)
		window.appInfo = obj.data
		window.appVersion = window.appInfo.Version
		// alert(window.appVersion)
		// alert(window.appInfo.Version)
	},10)
}

window.emH5GetNetworkStateCB = function(res) {
	setTimeout(function() {
		var obj = JSON.parse(res);
		window.helper.observer.trigger("article_showTip",obj);
	}, 10)
}

window.replaceBigEmoji = function(res){
	setTimeout(function() {
		window.embedHelper.observer.trigger("article_changeEmoji",res);
	}, 10)
}

module.exports = bridge


//////////////////
// WEBPACK FOOTER
// ./src/module/helper/bridge.js
// module id = 3
// module chunks = 0